import http from "../../core/services/http.service";

export default {
  getTransferNotes(params = null) {
    return http.get(`/api/v1/inventories/transfer-notes/`, {params});
  },
  getTransferNote(id, params = {}) {
    return http.get(`/api/v1/inventories/transfer-notes/${id}/`, {params});
  },
  updateTransferNote(id, data, expand = '') {
    return http.put(`/api/v1/inventories/transfer-notes/${id}/?expand=${expand}`, data);
  },
  createTransferNote(data, expand = '') {
    return http.post(`/api/v1/inventories/transfer-notes/?expand=${expand}`, data);
  },
  removeTransferNote(uuid) {
    return http.delete(`/api/v1/inventories/transfer-notes/${uuid}/`)
  },
};
